import React, { Component } from "react"
import FirstStep from "../components/RegisterForm"
import { Formik } from "formik"
import { string, boolean, ref, object, number } from "yup"
import { connect } from "react-redux"
import firebase from "../config/firebaseConfig"
import { showMessage } from "../ducks/alerts"
import {
  register,
  getTaxOffices,
  getUserInfo,
  takeNumbers,
  exportSaveErrMsg,
  exportSaveScssMsg,
} from "../ducks/profile"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
@withRouter
@connect(
  (state) => ({
    profile: state.profile,
    alerts: state.alerts,
    numbers: state.profile.numbers,
    isOwner: state.profile.owner,
    errMsg: state.profile.errMsg,
    scssMsg: state.profile.scssMsg,
  }),
  (dispatch) => ({
    onRegister: (data, redirect) => dispatch(register(data, redirect)),
    getTaxOffices: () => dispatch(getTaxOffices()),
    getUserInfo: (xin) => dispatch(getUserInfo(xin)),
    takeNumbers: (numbers) => dispatch(takeNumbers(numbers)),
    showMessage: (m, t) => dispatch(showMessage(m, t)),
    saveErrMsg: (text) => dispatch(exportSaveErrMsg(text)),
    saveScssMsg: (text) => dispatch(exportSaveScssMsg(text)),
  }),
)
class RegisterPage extends Component {
  state = {
    step: 1,
    email: "",
    iinOrBin: "",
    login: "",
    nds: false,
    address: "",
    numberNds: "",
    phone: "",
    fio: "",
    pass: "",
    rePass: "",
    region: "",
    taxRegions: "",
    taxOffice: "",
    taxTypes: "",
    companyType: "too",
    code: "",
    options: [
      { key: "too", text: "ТОО", value: "too" },
      { key: "ip", text: "ИП", value: "ip" },
      { key: "other", text: "Иное", value: "other" },
    ],
    limit: false,
    clickable: true,
    clickable2: true,
    services: [],
  }

  componentDidMount() {
    this.props.getTaxOffices()
  }

  // componentDidUpdate(prevProps) {
  //   if (this.props.isOwner.Success !== prevProps.isOwner.Success) {
  //     this.setState({ step: 2 })
  //   }
  // }

  handleChange = (e, { value }) => this.setState({ companyType: value })

  checboxHandleChange = () => {
    this.setState({ nds: !this.state.nds })
  }

  onSubmit = ({
    email,
    iinOrBin,
    options,
    nds,
    serialNds,
    numberNds,
    phone,
    pass,
    rePass,
    login,
    taxOffice,
    taxTypes,
    services,
  }) => {
    let phoneNumber = null
    phoneNumber = phone.split(" ")
    phoneNumber.splice(0, 1)
    const data = {
      login: String(iinOrBin),
      pass: pass,
      passConfirm: rePass,
      // company: `${this.state.companyType} ${"organizationName"}`,
      company: this.props.isOwner.obj ? this.props.isOwner.obj.name : "",
      address: this.props.isOwner.obj ? this.props.isOwner.obj.katoAddress : "",
      bin: String(iinOrBin),
      nds: serialNds !== undefined ? `${serialNds} ${numberNds}` : undefined,
      fio: this.props.isOwner.obj ? this.props.isOwner.obj.fio : "",
      phoneNumber: parseInt(phoneNumber.join("")),
      taxOffice: taxOffice,
      taxTypes: taxTypes,
      okedCode: this.props.isOwner.obj ? this.props.isOwner.obj.okedCode : "",
      mail: email,
      services,
    }
    const { onRegister } = this.props
    onRegister(data, this.props)
    this.setState({ limit: true })
  }

  stepOne = () => {
    this.setState({
      clickable: false,
    })
    this.props.getTaxOffices()
    const { numbers, showMessage } = this.props
    let appVerifier = window.recaptchaVerifier
    firebase
      .auth()
      .signInWithPhoneNumber(numbers.phone, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult
        if (numbers.phone.slice(-1) !== "_") {
          this.setState({ step: 2 })
        }
      })

      /* eslint handle-callback-err: "error" */
      .catch((error) => showMessage(error.message, "error"))
  }

  stepTwo = () => {
    const { numbers, showMessage, t } = this.props
    window.confirmationResult
      .confirm(numbers.code)
      .then((result) => {
        this.setState({ step: 3 })
        this.props.getTaxOffices()
      })
      .catch(function(error) {
        showMessage(t("Enter the correct code"), "error")
      })
  }

  stepThree = () => {
    this.setState({ step: 4 })
  }

  stepFour = () => {
    this.setState({ step: 5 })
  }

  prevStep = () => {
    this.setState({ step: this.state.step - 1 })
  }

  handleLimit = (e) => {
    this.setState({
      limit: true,
    })
  }

  selectTaxRegion = (value) => {
    this.setState({
      region: value,
    })
  }

  render() {
    const { t } = this.props
    const {
      step,
      email,
      iinOrBin,
      login,
      options,
      organizationName,
      address,
      nds,
      serialNds,
      numberNds,
      fio,
      phone,
      pass,
      rePass,
      region,
      taxRegions,
      taxOffice,
      taxTypes,
      companyType,
      services,
    } = this.state
    const values = {
      phone: phone,
      iinOrBin: iinOrBin,
      login: login,
      address: address,
      organizationName: organizationName,
      serialNds: serialNds,
      numberNds: numberNds,
      fio: fio,
      email: email,
      pass: pass,
      rePass: rePass,
      nds: nds,
      taxRegions: taxRegions,
      taxOffice: taxOffice,
      taxTypes: taxTypes,
      services: services,
    }

    const validationSchema = object({
      email: string(t("enterEmail"))
        .email(t("enterEmail"))
        .required(t("requiredField")),
      iinOrBin: string(t("enterUINorBIN"))
        .required(t("requiredField"))
        .length(12, t("UINLength")),
      taxOffice: string(t("chooseTaxOrgan")).required(t("chooseTaxOrgan")),
      // organizationName: string("Введите имя организации").required(
      //   "Поле обязательно для заполнения",
      // ),
      // address: string("Введите адрес").required(
      //   "Поле обязательно для заполнения",
      // ),
      nds: boolean(),
      serialNds: string().when("nds", {
        is: true,
        then: string()
          .required(t("requiredField"))
          .length(5, t("serieLength")),
      }),

      numberNds: string().when("nds", {
        is: true,
        then: string()
          .required(t("requiredField"))
          .length(7, t("VATLength")),
      }),
      // fio: string("Введите Ф.И.О.").required("Поле обязательно для заполнения"),
      phone: string(t("enterPhone")).required(t("requiredField")),
      taxTypes: string(t("chooseTaxType")).required(t("chooseTaxType")),
      pass: string()
        .required(t("requiredField"))
        .matches(/^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/, t("onlyLatin"))
        .matches(/(?=.*?[A-Z])/, t("capitalizeRequired"))
        .matches(/(?=.*?[0-9])/, t("numberRequired"))
        .min(8, t("lengthSymbols")),
      rePass: string(t("repeatPassword"))
        .required(t("requiredField"))
        .oneOf([ref("pass")], t("passwordDontMatch")),
    })
    let offices = []
    this.props.profile.taxOffices.map(
      (reg) => reg.taxCode === region && (offices = reg.taxOffices),
      // reg.taxCode === region && offices = reg.taxOffices
    )
    return (
      <div data-test="register-page-placeholder">
        <Formik
          render={(props) => (
            <FirstStep
              limit={this.state.limit}
              clickable={this.state.clickable}
              clickable2={this.state.clickable2}
              step={step}
              stepOne={this.stepOne}
              stepTwo={this.stepTwo}
              stepThree={this.stepThree}
              stepFour={this.stepFour}
              prevStep={this.prevStep}
              options={options}
              companyType={companyType}
              dropdownChange={this.handleChange}
              selectTaxRegion={this.selectTaxRegion}
              saveErrMsg={this.props.saveErrMsg}
              saveScssMsg={this.props.saveScssMsg}
              services={this.props.profile.services}
              taxRegions={this.props.profile.taxOffices.map((region) => ({
                key: region.taxCode,
                value: region.taxCode,
                text: region.name + " (" + region.taxCode + ")",
              }))}
              taxOffices={
                offices
                  ? offices.map((office) => ({
                      key: office.taxCode,
                      value: office.taxCode,
                      text: office.name + " (" + office.taxCode + ")",
                    }))
                  : []
              }
              taxTypes={this.props.profile.taxTypes.map((type) => ({
                key: type.id,
                value: type.id,
                text: type.name,
              }))}
              takeNumbers={this.props.takeNumbers}
              getUserInfo={this.props.getUserInfo}
              isOwner={this.props.isOwner}
              errMsg={this.props.errMsg}
              scssMsg={this.props.scssMsg}
              // defaultValue={defaultValue}
              {...props}
            />
          )}
          initialValues={values}
          validationSchema={validationSchema}
          onSubmit={this.onSubmit}
        />
      </div>
    )
  }
}

export default withTranslation()(RegisterPage)

// import React, { Component } from "react"
// import FirstStep from "../components/RegisterForm"
// import { Formik } from "formik"
// import { string, boolean, ref, object, number } from "yup"
// import { connect } from "react-redux"
// import firebase from "../config/firebaseConfig"
// import { showMessage } from "../ducks/alerts"
// import {
//   register,
//   getTaxOffices,
//   getUserInfo,
//   takeNumbers,
// } from "../ducks/profile"
// import { withRouter } from "react-router-dom"
// @withRouter
// @connect(
//   (state) => ({
//     profile: state.profile,
//     alerts: state.alerts,
//     numbers: state.profile.numbers,
//     isOwner: state.profile.owner,
//     errMsg: state.profile.errMsg,
//     scssMsg: state.profile.scssMsg,
//   }),
//   (dispatch) => ({
//     onRegister: (data, redirect) => dispatch(register(data, redirect)),
//     getTaxOffices: () => dispatch(getTaxOffices()),
//     getUserInfo: (xin) => dispatch(getUserInfo(xin)),
//     takeNumbers: (numbers) => dispatch(takeNumbers(numbers)),
//     showMessage: (m, t) => dispatch(showMessage(m, t)),
//   }),
// )
// export default class RegisterPage extends Component {
//   state = {
//     step: 1,
//     email: "",
//     iinOrBin: "",
//     login: "",
//     nds: false,
//     address: "",
//     numberNds: "",
//     phone: "",
//     fio: "",
//     pass: "",
//     rePass: "",
//     region: "",
//     taxRegions: "",
//     taxOffice: "",
//     taxTypes: "",
//     companyType: "too",
//     code: "",
//     options: [
//       { key: "too", text: "ТОО", value: "too" },
//       { key: "ip", text: "ИП", value: "ip" },
//       { key: "other", text: "Иное", value: "other" },
//     ],
//     limit: false,
//     clickable: true,
//     clickable2: true,
//     services: [],
//   }

//   componentDidMount() {
//     this.props.getTaxOffices()
//   }

//   // componentDidUpdate(prevProps) {
//   //   if (this.props.isOwner.Success !== prevProps.isOwner.Success) {
//   //     this.setState({ step: 2 })
//   //   }
//   // }

//   handleChange = (e, { value }) => this.setState({ companyType: value })

//   checboxHandleChange = () => {
//     this.setState({ nds: !this.state.nds })
//   }

//   onSubmit = ({
//     email,
//     iinOrBin,
//     options,
//     nds,
//     serialNds,
//     numberNds,
//     phone,
//     pass,
//     rePass,
//     login,
//     taxOffice,
//     taxTypes,
//     services,
//   }) => {
//     let phoneNumber = null
//     phoneNumber = phone.split(" ")
//     phoneNumber.splice(0, 1)
//     const data = {
//       login: String(iinOrBin),
//       pass: pass,
//       passConfirm: rePass,
//       // company: `${this.state.companyType} ${"organizationName"}`,
//       company: this.props.isOwner.obj ? this.props.isOwner.obj.name : "",
//       address: this.props.isOwner.obj ? this.props.isOwner.obj.katoAddress : "",
//       bin: String(iinOrBin),
//       nds: serialNds !== undefined ? `${serialNds} ${numberNds}` : undefined,
//       fio: this.props.isOwner.obj ? this.props.isOwner.obj.fio : "",
//       phoneNumber: parseInt(phoneNumber.join("")),
//       taxOffice: taxOffice,
//       taxTypes: taxTypes,
//       okedCode: this.props.isOwner.obj ? this.props.isOwner.obj.okedCode : "",
//       mail: email,
//       services,
//     }
//     const { onRegister } = this.props
//     onRegister(data, this.props)
//     this.setState({ limit: true })
//   }

//   stepOne = () => {
//     this.setState({
//       clickable: false,
//     })
//     this.props.getTaxOffices()
//     const { numbers, showMessage } = this.props
//     let appVerifier = window.recaptchaVerifier
//     firebase
//       .auth()
//       .signInWithPhoneNumber(numbers.phone, appVerifier)
//       .then((confirmationResult) => {
//         window.confirmationResult = confirmationResult
//         if (numbers.phone.slice(-1) !== "_") {
//           this.setState({ step: 2 })
//         }
//       })
//       /* eslint handle-callback-err: "error" */
//       .catch((error) => showMessage(error.message, "error"))
//   }

//   stepTwo = () => {
//     const { numbers, showMessage } = this.props
//     window.confirmationResult
//       .confirm(numbers.code)
//       .then((result) => {
//         this.setState({ step: 3 })
//         this.props.getTaxOffices()
//       })
//       .catch(function(error) {
//         showMessage("Введите корректный код", "error")
//       })
//   }

//   stepThree = () => {
//     this.setState({ step: 4 })
//   }

//   stepFour = () => {
//     this.setState({ step: 5 })
//   }

//   prevStep = () => {
//     this.setState({ step: this.state.step - 1 })
//   }

//   handleLimit = (e) => {
//     this.setState({
//       limit: true,
//     })
//   }

//   selectTaxRegion = (value) => {
//     this.setState({
//       region: value,
//     })
//   }

//   render() {
//     const {
//       step,
//       email,
//       iinOrBin,
//       login,
//       options,
//       organizationName,
//       address,
//       nds,
//       serialNds,
//       numberNds,
//       fio,
//       phone,
//       pass,
//       rePass,
//       region,
//       taxRegions,
//       taxOffice,
//       taxTypes,
//       companyType,
//       services,
//     } = this.state
//     const values = {
//       phone: phone,
//       iinOrBin: iinOrBin,
//       login: login,
//       address: address,
//       organizationName: organizationName,
//       serialNds: serialNds,
//       numberNds: numberNds,
//       fio: fio,
//       email: email,
//       pass: pass,
//       rePass: rePass,
//       nds: nds,
//       taxRegions: taxRegions,
//       taxOffice: taxOffice,
//       taxTypes: taxTypes,
//       services: services,
//     }

//     const validationSchema = object({
//       email: string("Введите Email")
//         .email("Введите корректный email")
//         .required("Поле обязательно для заполнения"),
//       iinOrBin: string("Введите ИИН/БИН")
//         .required("Поле обязательно для заполнения")
//         .length(12, "ИИН/БИН состоит из 12 символов"),
//       taxOffice: string("Выберите налоговый орган").required(
//         "Выберите налоговый орган",
//       ),
//       // organizationName: string("Введите имя организации").required(
//       //   "Поле обязательно для заполнения",
//       // ),
//       // address: string("Введите адрес").required(
//       //   "Поле обязательно для заполнения",
//       // ),
//       nds: boolean(),
//       serialNds: string().when("nds", {
//         is: true,
//         then: string()
//           .required("Поле обязательно для заполнения")
//           .length(5, "Серия должна состоять из пяти знаков"),
//       }),

//       numberNds: string().when("nds", {
//         is: true,
//         then: string()
//           .required("Поле обязательно для заполнения")
//           .length(7, "Номер НДС должен состоять из 7 знаков"),
//       }),
//       // fio: string("Введите Ф.И.О.").required("Поле обязательно для заполнения"),
//       phone: string("Введите телефон").required(
//         "Поле обязательно для заполнения",
//       ),
//       taxTypes: string("Выберите тип налога").required("Выберите тип налога"),
//       pass: string()
//         .required("Поле обязательно для заполнения")
//         .matches(
//           /^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/,
//           "Только символы английского алфавита ",
//         )
//         .matches(/(?=.*?[A-Z])/, "Не менее одной заглавной буквы")
//         .matches(/(?=.*?[0-9])/, "Не менее одной цифры")
//         .min(8, "не менее 8 символов"),
//       rePass: string("Повторите пароль")
//         .required("Поле обязательно для заполнения")
//         .oneOf([ref("pass")], "Пароли на совпадают"),
//     })
//     let offices = []
//     this.props.profile.taxOffices.map(
//       (reg) => reg.taxCode === region && (offices = reg.taxOffices),
//       // reg.taxCode === region && offices = reg.taxOffices
//     )
//     return (
//       <div data-test="register-page-placeholder">
//         <Formik
//           render={(props) => (
//             <FirstStep
//               limit={this.state.limit}
//               clickable={this.state.clickable}
//               clickable2={this.state.clickable2}
//               step={step}
//               stepOne={this.stepOne}
//               stepTwo={this.stepTwo}
//               stepThree={this.stepThree}
//               stepFour={this.stepFour}
//               prevStep={this.prevStep}
//               options={options}
//               companyType={companyType}
//               dropdownChange={this.handleChange}
//               selectTaxRegion={this.selectTaxRegion}
//               services={this.props.profile.services}
//               taxRegions={this.props.profile.taxOffices.map((region) => ({
//                 key: region.taxCode,
//                 value: region.taxCode,
//                 text: region.name + " (" + region.taxCode + ")",
//               }))}
//               taxOffices={
//                 offices
//                   ? offices.map((office) => ({
//                       key: office.taxCode,
//                       value: office.taxCode,
//                       text: office.name + " (" + office.taxCode + ")",
//                     }))
//                   : []
//               }
//               taxTypes={this.props.profile.taxTypes.map((type) => ({
//                 key: type.id,
//                 value: type.id,
//                 text: type.name,
//               }))}
//               takeNumbers={this.props.takeNumbers}
//               getUserInfo={this.props.getUserInfo}
//               isOwner={this.props.isOwner}
//               errMsg={this.props.errMsg}
//               scssMsg={this.props.scssMsg}
//               // defaultValue={defaultValue}
//               {...props}
//             />
//           )}
//           initialValues={values}
//           validationSchema={validationSchema}
//           onSubmit={this.onSubmit}
//         />
//       </div>
//     )
//   }
// }
